import React, { Component } from "react";
import {
  Card,
  ButtonDropdown,
  CustomInput,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { connect } from "react-redux";
import {
  setContainerClassnames,
  clickOnMobileMenu,
} from "../../../redux/actions";
import IntlMessages from "../../../helpers/IntlMessages";
import { END_POINT } from "../../../constants/defaultValues";
import classnames from "classnames";
import { Separator } from "../../../components/common/CustomBootstrap";
import ProductImage from "../../../components/common/ProductImage";

class LabelItemLeft extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownSplitOpen: false,
    };
  }

  toggleSplit = () => {
    this.setState((prevState) => ({
      dropdownSplitOpen: !prevState.dropdownSplitOpen,
    }));
  };

  menuButtonClick = (e, menuClickCount, containerClassnames) => {
    setTimeout(() => {
      var event = document.createEvent("HTMLEvents");
      event.initEvent("resize", false, false);
      window.dispatchEvent(event);
    }, 350);
    this.props.setContainerClassnames(
      menuClickCount,
      containerClassnames,
      this.props.selectedMenuHasSubItems
    );
  };

  onClickedItem = (item) => {
    this.props.onClickedItem(
      // callback
      item,
      this.menuButtonClick,
      [null, 1000, this.props.containerClassnames]
    );
  };

  render() {
    const { dropdownSplitOpen } = this.state;
    // console.log(this.props.item);

    return (
      <Card className="mb-3 custom-shadow">
        <div className="d-flex flex-row cursor-pointer">
          <div className={"d-flex flex-grow-1 min-width-zero"}>
            <ProductImage
              image={this.props.item.image}
              alt={this.props.item.name}
              fnbType={this.props.item.fnb_type}
              className="list-thumbnail responsive border-0"
              iconSize="40px"
            />
            <div
              onClick={() => {
                this.onClickedItem(this.props.item);
              }}
              className="card-body w-100 align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center"
            >
              <div className="list-item-heading mb-1 truncate d-block">
                <span>{this.props.item.name}</span>
              </div>
            </div>
            <div className="custom-control custom-checkbox pl-1 align-self-center pr-4">
              <ButtonDropdown
                isOpen={dropdownSplitOpen}
                toggle={this.toggleSplit}
                onClick={(e) => e.stopPropagation()}
                // onClick={() => {
                //     this.onClickedItem(this.props.item);
                // }}
              >
                <div
                  className={classnames(
                    "cursor-pointer btn btn-lg btn-secondary pl-4 pr-0 check-button check-all",
                    {
                      "btn-primary":
                        dropdownSplitOpen ||
                        this.props.selectedItems.includes(this.props.item.id),
                    }
                  )}
                >
                  <CustomInput
                    className="custom-checkbox mb-0 d-inline-block"
                    type="checkbox"
                    id={this.props.idx}
                    checked={this.props.selectedItems.includes(
                      this.props.item.id
                    )}
                    onChange={() => {
                      this.props.onChangeCheckbox(this.props.item.id);
                    }}
                    label={<span className={`custom-control-label`} />}
                  />
                </div>
                <DropdownToggle
                  caret
                  color={
                    dropdownSplitOpen ||
                    this.props.selectedItems.includes(this.props.item.id)
                      ? "primary"
                      : "secondary"
                  }
                  className="dropdown-toggle-split"
                  onClick={() => {
                    this.props.onChangeCheckbox(this.props.item.id);
                  }}
                />
                <DropdownMenu right>
                  <DropdownItem
                    className={classnames({
                      disable: this.props.isDisabledUpdate,
                    })}
                    onClick={() =>
                      this.props.isDisabledUpdate
                        ? null
                        : this.props.onUpdate(this.props.item)
                    }
                  >
                    <IntlMessages id="pages.update" ˇ />
                  </DropdownItem>
                  <Separator />
                  <DropdownItem
                    className={classnames({
                      disable: this.props.isDisabledDelete,
                    })}
                    onClick={() =>
                      this.props.isDisabledDelete
                        ? null
                        : this.props.onDelete(this.props.item)
                    }
                  >
                    <IntlMessages id="pages.delete" />
                  </DropdownItem>
                </DropdownMenu>
              </ButtonDropdown>
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = ({ menu }) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
  };
};
export default connect(mapStateToProps, {
  setContainerClassnames,
  clickOnMobileMenu,
})(LabelItemLeft);
